import React from 'react'
import about from '../assets/hospital-2026/hospital-front.jpg'
import Hero from '../components/pages/Hero'
import Biography from '../components/pages/Biography'
import whoever from '../assets/hospital-2026/care-team-outside.jpg'

const About = () => {
  return (
    <>
    <Hero
        title={"Learn More About Us | Sea be Cure Multi Super Speciality Hospital "}
        imageUrl={about}
        imageAlt="Front view of Sea Be Cure Hospital"
      />
      <Biography imageUrl={whoever} imageAlt="Sea Be Cure care team outside the hospital" />
    </>
  )
}

export default About
